export const ACCEPTED_FILE_TYPE_XLS_ONLY = {
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};

export const ACCEPTED_FILE_TYPE_XLS = {
  ...ACCEPTED_FILE_TYPE_XLS_ONLY,
  'text/csv': ['.csv'],
};

export const ACCEPTED_FILE_TYPE_XLSX = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/csv': ['.csv'],
};

export const ACCEPTED_FILE_TYPE_IMAGE_VIDEO_ZIP = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'video/x-msvideo': ['.avi'],
  'video/mpeg': ['.mpeg'],
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
  'application/zip': ['.zip'],
};
